import React from "react";
import {
  Image,
  CapabilityBase,
  CapabilityTitle,
  CapabilitySubtitle,
  StyledCTA,
  StyledLink,
  ImageContainer,
  TextContainer,
  ButtonContainer,
} from "./capability-summary.styled";
import {
  CapabilityListSliceFragment,
  HeroInstantQuoteCapabilityFragment,
  HeroCenteredSliceFragment,
} from "../../types/graphql";
import { linkTo } from "../../utils/contentUtils";
import { GatsbyImage } from "gatsby-plugin-image";

interface ICapabilitySummaryProps {
  capability: CapabilityListSliceFragment["items"][number]["capability"];
}
const CapabilitySummary = (props: ICapabilitySummaryProps) => {
  const capability = props.capability?.document;
  const capabilityData = capability && "data" in capability && capability?.data;
  const capabilityHero = capabilityData && capabilityData?.body?.[0];
  let heroImage, title, subtitle, cta_link, cta_text;
  const fallBackImageURL =
    "https://images.prismic.io/xometry-marketing/22f57c83-4e94-4a13-8c36-68c8235d12cd_Logomark_Xometry_Blue.png?auto=compress,format";
  if (
    capabilityHero &&
    "slice_type" in capabilityHero &&
    capabilityHero?.slice_type === "instant_quote_hero"
  ) {
    const capabilityPrimary = (
      capabilityHero as HeroInstantQuoteCapabilityFragment
    ).primary;
    heroImage = capabilityPrimary?.page_image;
    title = capabilityPrimary?.capability_title?.text;
    subtitle = capabilityPrimary?.capability_subtitle?.text;
    cta_link = capabilityPrimary?.quote_cta_link;
    cta_text = capabilityPrimary?.quote_cta_text;
  } else if (
    capabilityHero &&
    "slice_type" in capabilityHero &&
    capabilityHero?.slice_type === "centered_hero"
  ) {
    const capabilityPrimary = (capabilityHero as HeroCenteredSliceFragment)
      .primary;
    heroImage = capabilityPrimary?.image;
    title = capabilityPrimary?.title;
    subtitle = capabilityPrimary?.subtitle?.text;
    cta_link = capabilityPrimary?.cta_link;
    cta_text = capabilityPrimary?.cta_text;
  }
  return (
    (capabilityHero && capability && (
      <CapabilityBase>
        {(heroImage?.gatsbyImageData && (
          <ImageContainer>
            <GatsbyImage
              image={heroImage.gatsbyImageData}
              alt={heroImage.alt || "Xometry Capability"}
              style={{
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
            />
          </ImageContainer>
        )) || (
          <ImageContainer>
            <Image src={fallBackImageURL} alt={"Xometry Logo"} />
          </ImageContainer>
        )}
        <TextContainer>
          {title && <CapabilityTitle>{title}</CapabilityTitle>}
          {subtitle && <CapabilitySubtitle>{subtitle}</CapabilitySubtitle>}
          <ButtonContainer>
            {cta_link && cta_text && (
              <StyledCTA
                kind="primary"
                scale="large"
                pageSection="capability-list"
                ctaText={cta_text}
                linkURL={cta_link.url}
                target={cta_link?.target}
                additionalEventProps={{
                  capability: title,
                  page_type: "capability",
                }}
              />
            )}
            <StyledLink to={linkTo(capability)}>{title}</StyledLink>
          </ButtonContainer>
        </TextContainer>
      </CapabilityBase>
    )) || <></>
  );
};

export default CapabilitySummary;
